// src/components/ProtectedLayout.js
import Topbar from './Components/Topbar';
import Dashboard from './Components/Dashboard';
import { Outlet } from 'react-router-dom';
import { AssetProvider } from "./Context/MasterContext/AssetContext";
import { ServiceProvider } from './Context/MasterContext/ServiceContext';
import { MasterDataProvider } from './Context/masterDataContext';
import { CRMDataProvider } from './Context/CRMContext';

const ProtectedLayout = () => {
  return (
    <>
      <MasterDataProvider>
        <AssetProvider>
          <ServiceProvider>
            <CRMDataProvider>
              <Topbar />
              <Dashboard />
              <div className="main" id="main">
                <Outlet />
              </div>
            </CRMDataProvider>
          </ServiceProvider>
        </AssetProvider>
      </MasterDataProvider>

    </>
  );
};

export default ProtectedLayout;